export const TRAVEL_QUOTE_STEP_KEYS = {
  PERSONAL_DETAILS: "personalDetails",
  TRAVEL_DETAILS: "travelDetails",
  QUOTE_SELECTION: "quoteSelection",
  DOCUMENT_UPLOAD: "documentUpload",
  ADDITIONAL_INFO: "additionalInfo",
  PAYMENT: "payment",
} as const;

export type TravelQuoteStepKey =
  (typeof TRAVEL_QUOTE_STEP_KEYS)[keyof typeof TRAVEL_QUOTE_STEP_KEYS];
